const axios = require("axios").default;

window.addEventListener("load", function () {
	const formSelectBtns = document.querySelectorAll(".formToggleBtn");
	const formGeneral = document.querySelector("#contact-form-general");
	const formCandidate = document.querySelector("#contact-form-candidate");
	const formClient = document.querySelector("#contact-form-client");
	let formNumber = document.querySelector(".form-number");
	const allForms = document.querySelectorAll(".contact-form");

	formSelectBtns.forEach((btn) => {
		btn.addEventListener("click", function () {
			let button = btn.querySelector("button");
			let formResponse = document.querySelector(".form-response");
			formResponse.innerHTML = "";

			formSelectBtns.forEach((btns) => {
				btns.classList.remove("current");
			});

			allForms.forEach((form) => {
				form.classList.add("form-hide");
			});

			switch (button.id) {
				case "btn-contact-form-general":
					formGeneral.classList.remove("form-hide");
					formGeneral.classList.add("form-show");
					formGeneral.reset();
					formNumber.innerHTML = "03";
					button.parentNode.classList.add("current");
					break;
				case "btn-contact-form-candidate":
					formCandidate.classList.remove("form-hide");
					formCandidate.classList.add("form-show");
					formCandidate.reset();
					formNumber.innerHTML = "01";
					button.parentNode.classList.add("current");
					break;
				case "btn-contact-form-client":
					formClient.classList.remove("form-hide");
					formClient.classList.add("form-show");
					formClient.reset();
					formNumber.innerHTML = "02";
					button.parentNode.classList.add("current");
					break;
				default:
			}
		});
	});

	//Contact form general
	const contactFormGeneral = document.querySelector("#contact-form-general");
	const contactFormClient = document.querySelector("#contact-form-client");
	const contactFormCandidate = document.querySelector(
		"#contact-form-candidate"
	);

	// target on submission event
	if (contactFormGeneral) {
		contactFormGeneral.addEventListener("submit", (evt) => {
			// Stop it submitting
			evt.preventDefault();

			// Run Ajax function
			contact_form_general();
		});
	}

	if (contactFormClient) {
		contactFormClient.addEventListener("submit", (evt) => {
			// Stop it submitting
			evt.preventDefault();

			// Run Ajax function
			contact_form_client();
		});
	}

	if (contactFormCandidate) {
		contactFormCandidate.addEventListener("submit", (evt) => {
			// Stop it submitting
			evt.preventDefault();

			// Run Ajax function
			contact_form_candidate();
		});
	}

	function contact_form_general() {
		// create FormData from form fields
		let form_data = new FormData(
			document.getElementById("contact-form-general")
		);
		// add the wordpress ajax action to the FormData
		form_data.append("action", "contact_form_general");

		// add a class for ajaxing for user UI and to stop resubmission (add sudo overlay to form)
		contactFormGeneral.classList.add("ajaxing");

		// send data to app/ajax.php
		axios
			.post(ajaxurl, form_data)
			.then(function (ajax_response) {
				// remove ajaxing class
				contactFormGeneral.classList.remove("ajaxing");

				console.log(ajax_response.data);

				let errorMsg = document.querySelector(
					"#contact-form-wrapper-general .form-response--error"
				);

				// deal with response
				if (ajax_response.data.status == "success") {
					let successMsg = document.querySelector(
						"#contact-form-wrapper-general .form-response--success"
					);
					successMsg.classList.add("show");
					formGeneral.classList.add("form-hide");
					errorMsg.classList.remove("show");
				} else {
					errorMsg.classList.add("show");

					ajax_response.data.errors.forEach((error) => {
						let errorMessage = document.createElement("p");
						errorMessage.textContent = error;
						errorMsg.append(errorMessage);
					});
				}
			})
			.catch(function (error) {
				console.log("[Contact Form Ajax Error]");

				let errorMsg = document.querySelector(
					"#contact-form-wrapper-general .form-response--error"
				);

				console.log(errorMsg);

				errorMsg.classList.add("show");
			});
	}

	function contact_form_client() {
		// create FormData from form fields
		let form_data = new FormData(
			document.getElementById("contact-form-client")
		);
		// add the wordpress ajax action to the FormData
		form_data.append("action", "contact_form_client");

		// add a class for ajaxing for user UI and to stop resubmission (add sudo overlay to form)
		contactFormClient.classList.add("ajaxing");

		// send data to app/ajax.php
		axios
			.post(ajaxurl, form_data)
			.then(function (ajax_response) {
				// remove ajaxing class
				contactFormClient.classList.remove("ajaxing");

				console.log(ajax_response.data);

				let errorMsg = document.querySelector(
					"#contact-form-wrapper-client .form-response--error"
				);

				// deal with response
				if (ajax_response.data.status == "success") {
					let successMsg = document.querySelector(
						"#contact-form-wrapper-client .form-response--success"
					);
					successMsg.classList.add("show");
					formClient.classList.add("form-hide");
					errorMsg.classList.remove("show");
				} else {
					errorMsg.classList.add("show");

					ajax_response.data.errors.forEach((error) => {
						let errorMessage = document.createElement("p");
						errorMessage.textContent = error;
						errorMsg.append(errorMessage);
					});
				}
			})
			.catch(function (error) {
				console.log("[Contact Form Ajax Error]");

				let errorMsg = document.querySelector(
					"#contact-form-wrapper-client .form-response--error"
				);
				errorMsg.classList.add("show");
			});
	}

	function contact_form_candidate() {
		// create FormData from form fields
		let form_data = new FormData(
			document.getElementById("contact-form-candidate")
		);
		// add the wordpress ajax action to the FormData
		form_data.append("action", "contact_form_candidate");

		contactFormCandidate.classList.add("ajaxing");

		let errorMsg = document.querySelector(
			"#contact-form-wrapper-candidate .form-response--error"
		);

		// send data to app/ajax.php
		axios
			.post(ajaxurl, form_data)
			.then(function (ajax_response) {
				// remove ajaxing class
				contactFormCandidate.classList.remove("ajaxing");
				console.log(ajax_response.data);

				// deal with response
				if (ajax_response.data.status == "success") {
					let successMsg = document.querySelector(
						"#contact-form-wrapper-candidate .form-response--success"
					);
					successMsg.classList.add("show");
					formCandidate.classList.add("form-hide");
					errorMsg.classList.remove("show");
				} else {
					errorMsg.classList.add("show");

					ajax_response.data.errors.forEach((error) => {
						let errorMessage = document.createElement("p");
						errorMessage.textContent = error;
						errorMsg.append(errorMessage);
					});
				}
			})
			.catch(function (error) {
				let errorMsg = document.querySelector(
					"#contact-form-wrapper-candidate .form-response--error"
				);
				errorMsg.classList.add("show");
			});
	}
});
